<script setup>
import { DrawerDescription as DrawerDescriptionPrimitive } from "vaul-vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <DrawerDescriptionPrimitive
    data-slot="drawer-description"
    :class="cn('text-sm text-muted-foreground', props.class)"
  >
    <slot />
  </DrawerDescriptionPrimitive>
</template>
